import { render, staticRenderFns } from "./GenderPieChart.vue?vue&type=template&id=7cdbfea0&scoped=true&"
import script from "./GenderPieChart.vue?vue&type=script&lang=js&"
export * from "./GenderPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdbfea0",
  null
  
)

export default component.exports